var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTripDetails = function SvgTripDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 149.734,
    height: 136.822,
    viewBox: "0 0 116.7 115"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".trip-details_svg__st9{fill:#4287c6}.trip-details_svg__st158{fill:#46586b}.trip-details_svg__st159{fill:#fc5210}.trip-details_svg__st161{fill:#8fe2ef}.trip-details_svg__st162{fill:#f4d2a8}.trip-details_svg__st163{fill:#89d8e5}.trip-details_svg__st164{fill:#f2c58f}.trip-details_svg__st171{fill:#ffdcb6}")), /*#__PURE__*/React.createElement("g", {
    id: "trip-details_svg__Layer_2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.3,
    cy: 57.5,
    r: 57.5,
    style: {
      opacity: 0.35,
      fill: "#a3cbe8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2 78.3H18.9l-6.5-34c-1.6-8.7 5-16.7 13.8-16.7h61.6c8.8 0 15.4 8 13.8 16.7z",
    style: {
      fill: "#2f5782"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3 94h-70c-8.7 0-15.7-7.1-15.7-15.8v-.8H109v.9C109 87 102 94 93.3 94",
    className: "trip-details_svg__st9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7 94h-6.5c-7.4 0-13.7-5.1-15.3-12.3L.2 60.5c-1.3-5.8 3.2-11.3 9.1-11.3h.2c4.4 0 8.2 3.1 9.1 7.4zM90 94h6.5c7.4 0 13.7-5.1 15.3-12.3l4.6-21.2c1.3-5.8-3.2-11.3-9.1-11.3h-.2c-4.4 0-8.2 3.1-9.1 7.4z",
    className: "trip-details_svg__st9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9 108h-5.5l4.9-14h8.8zM96.7 108h5.5l-4.9-14h-8.7z",
    className: "trip-details_svg__st158"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m51.6 12.9-2.4 8.5c-1.2 5.8-1.2 7.2-3.8 6.9 0 0 7.3 6.6 14.2-.2z",
    className: "trip-details_svg__st159"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m67.6 12.9 2.4 8.5c1.5 5.4 1.9 6.5 3.8 6.9 0 0-7.3 6.6-14.2-.2z",
    style: {
      fill: "#50050a"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m67.6 12.9 2.4 8.5c1.5 5.4 1.9 6.5 3.8 6.9 0 0-7.3 6.6-14.2-.2z",
    className: "trip-details_svg__st159"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 39.6c-3.8 0-6.9-3.1-6.9-6.9v-3.3l-.8.1c-.9.2-1.8.4-2.6.8 0 0-1.3 15.5-3 16.2l4.1 23.3 9.4 3.2z",
    className: "trip-details_svg__st161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m59.6 39.6.1-11.3-7 1.1v3.3c0 3.9 3 6.9 6.9 6.9",
    className: "trip-details_svg__st161"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m43.1 36.9-3.9 9.9-5.8 11.4 5.2-.3 7.5-11.4v-.2.1c1.8-.6 3-16.2 3-16.2-2.7 1.4-5 3.8-6 6.7",
    className: "trip-details_svg__st162"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7 39.6c3.8 0 6.9-3.1 6.9-6.9v-3.3l.9.1c.9.2 1.8.4 2.6.8 0 0 1.3 15.5 3 16.2L69 69.9l-9.4 3.2z",
    className: "trip-details_svg__st163"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m59.7 39.6-.1-11.3 7 1.1v3.3c0 3.9-3.1 6.9-6.9 6.9",
    className: "trip-details_svg__st163"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m76.1 36.9 3.9 9.9 5.8 11.4-5.2-.2-7.5-11.4v-.2.1c-1.8-.6-3-16.2-3-16.2 2.8 1.3 5 3.7 6 6.6",
    className: "trip-details_svg__st164"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3 18.7v4.1c0 4.5 3.3 9.4 7.9 9.4h.4V13z",
    className: "trip-details_svg__st162"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 9.4v22.7c4.4-.3 8.3-5 8.3-9.4v-4.1z",
    className: "trip-details_svg__st164"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 7h-1.2c-3.9 0-7 3.6-7 8v3.7h.1c3.6 0 8.2-7.1 8.2-7.7V7z",
    className: "trip-details_svg__st159"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6 7h1.2c3.9 0 7 3.6 7 8v3.7h-.1c-3.6 0-8.2-7.1-8.2-7.7V7z",
    className: "trip-details_svg__st159"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.4 7H61z",
    style: {
      fill: "#ff573d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7 78.8 32 73.6c3.3.9 12.9 3.3 22.7 5.2",
    style: {
      fill: "#ffc78f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 73.6",
    style: {
      fill: "#af5182"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7 81c1.1-1.5 2.5-2.8 4.1-3.8l4.2-1.5 2.6-2.6c1.3-.8 2.9-1 4.4-.5l2.3.7c.4.1.9.2 1.3.3l-1.2 2.8 1.9 2.6c-1.3.1-2.4.1-3.5.1-2.1-.1-15.2 3.6-15.2 3.6-1-.1-1.4-1-.9-1.7",
    className: "trip-details_svg__st164"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m50.5 73.6 1-2.2L76.2 64c2.9-1.4 6.2-1.6 9.3-.5h.1c2.2.7 3.5 2.9 3.1 5.2v.1c-.3 1.8-1.5 3.2-3.2 3.8 0 0-.4.1-1 .3l-20 4.5c-4.7.9-9.4 1.6-13.3 1.8l-1.9-2.6z",
    style: {
      fill: "#39c9c5"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3 81.8s-.3-2-2.1-3.1l-7.1-2.9-2.1-2.7c-1.5-.9-1.5-.6-3.2-.1L72 74.3c-.5.2-1 .2-1.5.3.9 2 .6 4.2-.6 6l-.1.2c1.4.1 4.6.1 5.8.3 9 1.6 12.5 3.8 12.5 3.8.9-.1 1.8-2.4 1.2-3.1M80.8 53.4c-2.2.4-7.7 9.4-7.7 9.4l-.9-.6c-2-1.3-4.3-1.7-6.6-1.4-.2 0-.4.1-.6.1-1.2.3.6 3.9.6 3.9.8 2.1 2.7 3.5 4.9 3.8h.1c1.4.2 2.9-.2 4.1-1l8.1-5.6 2.5-1.7c.4-.4 2.5-6.8-4.5-6.9",
    className: "trip-details_svg__st162"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.1 77.2c0-.9-.1-1.7-.5-2.5l-1.1-2.5-28-8.4c-3.3-1.6-7.1-1.8-10.5-.6h-.1c-2.4.8-3.9 3.3-3.5 5.9v.1c.2 1.1.7 2.1 1.5 2.9 4.5 1.3 15.3 4.3 24.4 4.9 9.3.5 15.6.3 17.8.2",
    style: {
      fill: "#8ee0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1 76.9c-9.1-.6-19.9-3.6-24.4-4.9 1.2 2.9 20 5.8 20 5.8L68.9 82l.9-1.2.1-.2c.7-1 1.1-2.2 1.1-3.4-2.1.1-8.4.3-17.9-.3",
    style: {
      fill: "#28cece"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47 64.8c.4-.4 4.5-2.8 6.7-4-2.3-.3-4.7.1-6.6 1.4l-.9.6s-5.5-9-7.6-9.4h-.1c-7 .1-4.9 6.5-4.3 7l2.5 1.7c4 2.1 9.9 3.2 10.3 2.7",
    className: "trip-details_svg__st171"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 60.9s-.4-.1-.7-.1c-2.1 1.2-6.3 3.5-6.7 4s-6.4-.6-10.3-2.7l8.1 5.6c1.2.8 2.6 1.2 4.1 1h.1c2.2-.3 4.1-1.8 4.9-3.8-.1 0 1.7-3.7.5-4",
    className: "trip-details_svg__st171"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 9.4c-4.5 0-8.2 3.7-8.2 8.2v1.2h8.3z",
    style: {
      fill: "#ff7d4a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8 17.6c0-4.5-3.7-8.2-8.2-8.2h-.1v9.4h8.3z",
    style: {
      fill: "#ff642e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6 69.2h31.8v2.1H43.6z",
    style: {
      fill: "#101d2b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9 47H45.2c-.9 0-1.5.6-1.5 1.4v20.7L75 47.4c-.3-.2-.7-.4-1.1-.4",
    style: {
      fill: "#91a2af"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9 47.4 43.6 69.1h31.8V48.5c.1-.5-.1-.8-.5-1.1",
    style: {
      fill: "#798e9b"
    }
  })));
};
export default SvgTripDetails;